<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import type { RoutedCustomerViewComponentProps } from '@/types';
  import AdmissionStatus from '@/components/customerPage/AdmissionStatus/AdmissionStatus.vue';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';
  import AdmissionValidator from '@/components/customerPage/AdmissionStatus/AdmissionValidator.vue';

  defineOptions({ name: 'ProfileView', inheritAttrs: false });

  defineProps<RoutedCustomerViewComponentProps>();

  const { t } = useI18n();
  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const CustomerProfile = getAsyncComponentWithLoader(() => import('@/components/customerProfilePage/CustomerProfile/CustomerProfile.vue'));
</script>

<template>
  <PageContent :is-status-box-opened="isStatusBoxOpened">
    <template #header>
      <AdmissionStatus class="md:container" />
      <h1 class="md:container">
        {{ t('pages.customerProfile.title') }}
      </h1>
      <AdmissionValidator class="md:container" />
    </template>
    <CustomerProfile />
  </PageContent>
</template>
